import type { NotificationType } from '@coreltb/shared/types';

/** Krótka nazwa rodzaju powiadomienia (etykieta na liście) — wszystkie typy, po polsku. */
const LABELS: Record<NotificationType, string> = {
  reminder_contact: 'Kontakt',
  reminder_meeting: 'Spotkanie',
  reminder_offer: 'Kontakt po ofercie',
  reminder_send_offer: 'Wyślij ofertę',
  offer_opened: 'Mail otwarty',
  offer_clicked: 'Obejrzał ofertę',
  offer_bounced: 'Mail nie dotarł',
  offer_reaction: 'Odpowiedź na ofertę',
  lead_assigned: 'Przypisanie',
  lead_unassigned: 'Nowy kontakt',
  lead_resubmitted: 'Klient wrócił',
  lead_hot: 'Gorący lead',
  discount_request_pending: 'Prośba o rabat',
  discount_request_resolved: 'Decyzja o rabacie',
  offer_deletion_request_pending: 'Prośba o usunięcie',
  offer_deletion_request_resolved: 'Decyzja o usunięciu',
  lead_note_annotated: 'Komentarz do notatki',
  project_note_mention: 'Wzmianka w projekcie',
  feedback_replied: 'Odpowiedź w uwadze',
  feedback_tester_replied: 'Tester odpisał',
  lead_note_by_other: 'Notatka',
  lead_edited_by_other: 'Zmiana danych',
  project_created: 'Nowy projekt',
  project_assignment_added: 'Dodano do projektu',
  project_assignment_removed: 'Usunięto z projektu',
  project_manager_changed: 'Nowy kierownik',
  project_salesperson_changed: 'Nowy opiekun',
  project_status_changed: 'Status projektu',
  project_cancelled: 'Projekt anulowany',
  project_document_uploaded: 'Nowy dokument',
  system: 'System',
};

export function notificationLabel(type: NotificationType): string {
  return LABELS[type] ?? 'Powiadomienie';
}
